export default {
	"InAdlam": false,
	"InAegean_Numbers": false,
	"InAhom": false,
	"InAlchemical_Symbols": false,
	"InAlphabetic_Presentation_Forms": false,
	"InAnatolian_Hieroglyphs": false,
	"InAncient_Greek_Musical_Notation": false,
	"InAncient_Greek_Numbers": false,
	"InAncient_Symbols": false,
	"InArabic": false,
	"InArabic_Extended_A": false,
	"InArabic_Mathematical_Alphabetic_Symbols": false,
	"InArabic_Presentation_Forms_A": false,
	"InArabic_Presentation_Forms_B": false,
	"InArabic_Supplement": false,
	"InArmenian": false,
	"InArrows": false,
	"InAvestan": false,
	"InBalinese": false,
	"InBamum": false,
	"InBamum_Supplement": false,
	"InBasic_Latin": false,
	"InBassa_Vah": false,
	"InBatak": false,
	"InBengali": false,
	"InBhaiksuki": false,
	"InBlock_Elements": false,
	"InBopomofo": false,
	"InBopomofo_Extended": false,
	"InBox_Drawing": false,
	"InBrahmi": false,
	"InBraille_Patterns": false,
	"InBuginese": false,
	"InBuhid": false,
	"InByzantine_Musical_Symbols": false,
	"InCJK_Compatibility": false,
	"InCJK_Compatibility_Forms": false,
	"InCJK_Compatibility_Ideographs": false,
	"InCJK_Compatibility_Ideographs_Supplement": false,
	"InCJK_Radicals_Supplement": false,
	"InCJK_Strokes": false,
	"InCJK_Symbols_And_Punctuation": false,
	"InCJK_Unified_Ideographs": false,
	"InCJK_Unified_Ideographs_Extension_A": false,
	"InCJK_Unified_Ideographs_Extension_B": false,
	"InCJK_Unified_Ideographs_Extension_C": false,
	"InCJK_Unified_Ideographs_Extension_D": false,
	"InCJK_Unified_Ideographs_Extension_E": false,
	"InCJK_Unified_Ideographs_Extension_F": false,
	"InCarian": false,
	"InCaucasian_Albanian": false,
	"InChakma": false,
	"InCham": false,
	"InCherokee": false,
	"InCherokee_Supplement": false,
	"InChess_Symbols": false,
	"InCombining_Diacritical_Marks": false,
	"InCombining_Diacritical_Marks_Extended": false,
	"InCombining_Diacritical_Marks_For_Symbols": false,
	"InCombining_Diacritical_Marks_Supplement": false,
	"InCombining_Half_Marks": false,
	"InCommon_Indic_Number_Forms": false,
	"InControl_Pictures": false,
	"InCoptic": false,
	"InCoptic_Epact_Numbers": false,
	"InCounting_Rod_Numerals": false,
	"InCuneiform": false,
	"InCuneiform_Numbers_And_Punctuation": false,
	"InCurrency_Symbols": false,
	"InCypriot_Syllabary": false,
	"InCyrillic": false,
	"InCyrillic_Extended_A": false,
	"InCyrillic_Extended_B": false,
	"InCyrillic_Extended_C": false,
	"InCyrillic_Supplement": false,
	"InDeseret": false,
	"InDevanagari": false,
	"InDevanagari_Extended": false,
	"InDingbats": false,
	"InDogra": false,
	"InDomino_Tiles": false,
	"InDuployan": false,
	"InEarly_Dynastic_Cuneiform": false,
	"InEgyptian_Hieroglyphs": false,
	"InElbasan": false,
	"InEmoticons": false,
	"InEnclosed_Alphanumeric_Supplement": false,
	"InEnclosed_Alphanumerics": false,
	"InEnclosed_CJK_Letters_And_Months": false,
	"InEnclosed_Ideographic_Supplement": false,
	"InEthiopic": false,
	"InEthiopic_Extended": false,
	"InEthiopic_Extended_A": false,
	"InEthiopic_Supplement": false,
	"InGeneral_Punctuation": false,
	"InGeometric_Shapes": false,
	"InGeometric_Shapes_Extended": false,
	"InGeorgian": false,
	"InGeorgian_Extended": false,
	"InGeorgian_Supplement": false,
	"InGlagolitic": false,
	"InGlagolitic_Supplement": false,
	"InGothic": false,
	"InGrantha": false,
	"InGreek_And_Coptic": false,
	"InGreek_Extended": false,
	"InGujarati": false,
	"InGunjala_Gondi": false,
	"InGurmukhi": false,
	"InHalfwidth_And_Fullwidth_Forms": false,
	"InHangul_Compatibility_Jamo": false,
	"InHangul_Jamo": false,
	"InHangul_Jamo_Extended_A": false,
	"InHangul_Jamo_Extended_B": false,
	"InHangul_Syllables": false,
	"InHanifi_Rohingya": false,
	"InHanunoo": false,
	"InHatran": false,
	"InHebrew": false,
	"InHigh_Private_Use_Surrogates": false,
	"InHigh_Surrogates": false,
	"InHiragana": false,
	"InIPA_Extensions": false,
	"InIdeographic_Description_Characters": false,
	"InIdeographic_Symbols_And_Punctuation": false,
	"InImperial_Aramaic": false,
	"InIndic_Siyaq_Numbers": false,
	"InInscriptional_Pahlavi": false,
	"InInscriptional_Parthian": false,
	"InJavanese": false,
	"InKaithi": false,
	"InKana_Extended_A": false,
	"InKana_Supplement": false,
	"InKanbun": false,
	"InKangxi_Radicals": false,
	"InKannada": false,
	"InKatakana": false,
	"InKatakana_Phonetic_Extensions": false,
	"InKayah_Li": false,
	"InKharoshthi": false,
	"InKhmer": false,
	"InKhmer_Symbols": false,
	"InKhojki": false,
	"InKhudawadi": false,
	"InLao": false,
	"InLatin_1_Supplement": false,
	"InLatin_Extended_A": false,
	"InLatin_Extended_Additional": false,
	"InLatin_Extended_B": false,
	"InLatin_Extended_C": false,
	"InLatin_Extended_D": false,
	"InLatin_Extended_E": false,
	"InLepcha": false,
	"InLetterlike_Symbols": false,
	"InLimbu": false,
	"InLinear_A": false,
	"InLinear_B_Ideograms": false,
	"InLinear_B_Syllabary": false,
	"InLisu": false,
	"InLow_Surrogates": false,
	"InLycian": false,
	"InLydian": false,
	"InMahajani": false,
	"InMahjong_Tiles": false,
	"InMakasar": false,
	"InMalayalam": false,
	"InMandaic": false,
	"InManichaean": false,
	"InMarchen": false,
	"InMasaram_Gondi": false,
	"InMathematical_Alphanumeric_Symbols": false,
	"InMathematical_Operators": false,
	"InMayan_Numerals": false,
	"InMedefaidrin": false,
	"InMeetei_Mayek": false,
	"InMeetei_Mayek_Extensions": false,
	"InMende_Kikakui": false,
	"InMeroitic_Cursive": false,
	"InMeroitic_Hieroglyphs": false,
	"InMiao": false,
	"InMiscellaneous_Mathematical_Symbols_A": false,
	"InMiscellaneous_Mathematical_Symbols_B": false,
	"InMiscellaneous_Symbols": false,
	"InMiscellaneous_Symbols_And_Arrows": false,
	"InMiscellaneous_Symbols_And_Pictographs": false,
	"InMiscellaneous_Technical": false,
	"InModi": false,
	"InModifier_Tone_Letters": false,
	"InMongolian": false,
	"InMongolian_Supplement": false,
	"InMro": false,
	"InMultani": false,
	"InMusical_Symbols": false,
	"InMyanmar": false,
	"InMyanmar_Extended_A": false,
	"InMyanmar_Extended_B": false,
	"InNKo": false,
	"InNabataean": false,
	"InNew_Tai_Lue": false,
	"InNewa": false,
	"InNumber_Forms": false,
	"InNushu": false,
	"InOgham": false,
	"InOl_Chiki": false,
	"InOld_Hungarian": false,
	"InOld_Italic": false,
	"InOld_North_Arabian": false,
	"InOld_Permic": false,
	"InOld_Persian": false,
	"InOld_Sogdian": false,
	"InOld_South_Arabian": false,
	"InOld_Turkic": false,
	"InOptical_Character_Recognition": false,
	"InOriya": false,
	"InOrnamental_Dingbats": false,
	"InOsage": false,
	"InOsmanya": false,
	"InPahawh_Hmong": false,
	"InPalmyrene": false,
	"InPau_Cin_Hau": false,
	"InPhags_Pa": false,
	"InPhaistos_Disc": false,
	"InPhoenician": false,
	"InPhonetic_Extensions": false,
	"InPhonetic_Extensions_Supplement": false,
	"InPlaying_Cards": false,
	"InPrivate_Use_Area": false,
	"InPsalter_Pahlavi": false,
	"InRejang": false,
	"InRumi_Numeral_Symbols": false,
	"InRunic": false,
	"InSamaritan": false,
	"InSaurashtra": false,
	"InSharada": false,
	"InShavian": false,
	"InShorthand_Format_Controls": false,
	"InSiddham": false,
	"InSinhala": false,
	"InSinhala_Archaic_Numbers": false,
	"InSmall_Form_Variants": false,
	"InSogdian": false,
	"InSora_Sompeng": false,
	"InSoyombo": false,
	"InSpacing_Modifier_Letters": false,
	"InSpecials": false,
	"InSundanese": false,
	"InSundanese_Supplement": false,
	"InSuperscripts_And_Subscripts": false,
	"InSupplemental_Arrows_A": false,
	"InSupplemental_Arrows_B": false,
	"InSupplemental_Arrows_C": false,
	"InSupplemental_Mathematical_Operators": false,
	"InSupplemental_Punctuation": false,
	"InSupplemental_Symbols_And_Pictographs": false,
	"InSupplementary_Private_Use_Area_A": false,
	"InSupplementary_Private_Use_Area_B": false,
	"InSutton_SignWriting": false,
	"InSyloti_Nagri": false,
	"InSyriac": false,
	"InSyriac_Supplement": false,
	"InTagalog": false,
	"InTagbanwa": false,
	"InTags": false,
	"InTai_Le": false,
	"InTai_Tham": false,
	"InTai_Viet": false,
	"InTai_Xuan_Jing_Symbols": false,
	"InTakri": false,
	"InTamil": false,
	"InTangut": false,
	"InTangut_Components": false,
	"InTelugu": false,
	"InThaana": false,
	"InThai": false,
	"InTibetan": false,
	"InTifinagh": false,
	"InTirhuta": false,
	"InTransport_And_Map_Symbols": false,
	"InUgaritic": false,
	"InUnified_Canadian_Aboriginal_Syllabics": false,
	"InUnified_Canadian_Aboriginal_Syllabics_Extended": false,
	"InVai": false,
	"InVariation_Selectors": false,
	"InVariation_Selectors_Supplement": false,
	"InVedic_Extensions": false,
	"InVertical_Forms": false,
	"InWarang_Citi": false,
	"InYi_Radicals": false,
	"InYi_Syllables": false,
	"InYijing_Hexagram_Symbols": false,
	"InZanabazar_Square": false
};

export const NAME_ALIAS = {};